/* unplugin-vue-components disabled */import { render } from "./Resource.vue?vue&type=template&id=4cc36767"
import script from "./Resource.vue?vue&type=script&lang=js"
export * from "./Resource.vue?vue&type=script&lang=js"

import "./Resource.vue?vue&type=style&index=0&id=4cc36767&lang=scss"

import exportComponent from "D:\\Project\\Juanfu\\hcontrol_download\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__